import { useCallback, useState } from 'react';
import { useToggle } from 'react-use';

import { TranslatableText } from '@dreryk/react-common';
import { Link, LinkSize } from '@dreryk/react-components';

import { EntitlementStatementCreateModal } from './modal/EntitlementStatementCreateModal';
import { EntitlementStatementPrintRenderer } from './modal/EntitlementStatementPrintRenderer';

type EntitlementStatementCreateLinkProps = {
   readonly patientId: number;
   readonly label: TranslatableText;
   readonly icon?: JSX.Element;
   readonly onPatientEntitlementsDocumentCreated: () => void;
};

export const EntitlementStatementCreateLink = (props: EntitlementStatementCreateLinkProps): JSX.Element => {
   const [showCreateModal, toggleShowCreateModal] = useToggle(false);
   const [entitlementStatementId, setEntitlementStatementId] = useState<number | undefined>();
   const [printWithExplanationsAndNotice, setPrintWithExplanationsAndNotice] = useState<boolean>();

   const handleCreateClick = useCallback(() => {
      toggleShowCreateModal(true);
   }, [toggleShowCreateModal]);

   const handleDataChanged = useCallback(
      () => {
         toggleShowCreateModal(false);
         props.onPatientEntitlementsDocumentCreated();
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [props.onPatientEntitlementsDocumentCreated, toggleShowCreateModal]
   );

   return (
      <>
         <Link
            testId={'addEntitlement'}
            label={props.label}
            icon={props.icon}
            onClick={handleCreateClick}
            size={LinkSize.NORMAL}
         />
         {entitlementStatementId ? (
            <EntitlementStatementPrintRenderer
               id={entitlementStatementId}
               setEntitlementStatementId={setEntitlementStatementId}
               printWithExplanationsAndNotice={printWithExplanationsAndNotice}
            />
         ) : null}
         {showCreateModal ? (
            <EntitlementStatementCreateModal
               patientId={props.patientId}
               onCancel={toggleShowCreateModal}
               onDataChanged={handleDataChanged}
               setEntitlementStatementId={setEntitlementStatementId}
               setPrintWithExplanationsAndNotice={setPrintWithExplanationsAndNotice}
            />
         ) : null}
      </>
   );
};
